export function OfflinePage() {
  return (
    <section className="panel rounded-[2rem] p-10 text-center">
      <p className="text-xs uppercase tracking-[0.3em] text-accent">Offline fallback</p>
      <h2 className="mt-4 font-display text-4xl font-bold">You are offline</h2>
      <p className="mx-auto mt-4 max-w-xl text-sm text-foreground/70">
        If this is your first visit, reconnect once to cache the app shell. If you have already
        installed Local Wave, your saved tracks and playlists will remain available from IndexedDB.
      </p>
    </section>
  );
}
